import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { AbstractStateInterface } from '../../interface/abstract';
import { ApiService } from '../../utils/apiService';
import { SummaryInterface } from '../../interface/summary';

type DataState = AbstractStateInterface<SummaryInterface>;

const initialState: DataState = {
  data: [],
  detail: null,
  loading: false,
};

export const getAggregateAnswerData = createAsyncThunk('/admin-api/summary', async (_, thunkAPI) => {
  try {
    const response = await ApiService(`/admin-api/summary`, 'GET', null);
    if (response.statusCode !== 200) {
      return thunkAPI.rejectWithValue({
        code: response.statusCode,
        error: response.error || 'Login failed',
      });
    }
    return {
      code: response.statusCode,
      data: response.data,
      message: response.message,
    };
  } catch (error: any) {
    return thunkAPI.rejectWithValue({
      code: error.response?.status || 500,
      error: error.message || 'Error',
    });
  }
});

const summarySlice = createSlice({
  name: 'summary',
  initialState,
  reducers: {
    resetSummarySlice: () => {
      return { ...initialState };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAggregateAnswerData.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAggregateAnswerData.fulfilled, (state, action) => {
        state.loading = false;
        if (Array.isArray(action.payload.data)) {
          state.data = action.payload.data as SummaryInterface[];
        } else {
          state.data = [];
        }
      })
      .addCase(getAggregateAnswerData.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { resetSummarySlice } = summarySlice.actions;
export default summarySlice.reducer;
